import { hydrateRoot, createRoot } from 'react-dom/client';
import { StrictMode } from 'react';
import App from './App';
import './styles/main.css';

const rootElement = document.getElementById('root')!;

// If the root has server-rendered content (actual DOM elements, not just
// SSR placeholder comments like <!--ssr-outlet-->), hydrate over it.
// In dev mode Vite serves the raw template, so the root only contains
// a comment node — use createRoot for a clean client render.
if (rootElement.childElementCount > 0) {
  hydrateRoot(
    rootElement,
    <StrictMode>
      <App />
    </StrictMode>
  );
} else {
  createRoot(rootElement).render(
    <StrictMode>
      <App />
    </StrictMode>
  );
}
